
import './App.css';
import AppRouter from './router/AppRouter';
import 'bootstrap/dist/css/bootstrap.css';

function App() {
  return (
    <div className="App">
        <AppRouter/>
    </div>
  );
}

export default App;
